<template>
  <div class="contact-wrapper">
    <div class="contact-header">
      <img src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/contact-header-0.png" alt="" />
      <img src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/contact-header-1.png" alt="" />
      <img src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/contact-header-2.png" alt="" />
      <img src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/contact-header-3.png" alt="" />
      <img src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/contact-header-4.png" alt="" />
      <img src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/contact-header-5.png" alt="" />
      <img src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/contact-header-6.png" alt="" />
      <img src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/contact-header-7.png" alt="" />
      <img src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/contact-header-8.png" alt="" />
    </div>
    <div class="vision">
      <div class="vision-title">{{ isChinese ? `公司愿景` : `Corporate Vision` }}</div>
      <div class="promotion-slogan3">{{ isChinese ? `开启AI海洋捕捞新时代!` : `Embark on a new era of AI ocean fishing!` }}</div>
      <div class="promotion-slogan2">{{  isChinese ? `助力中国从世界渔业大国成为渔业强国!` : `Help China transform from a world fishing power to a fishing powerhouse!` }}</div>
      <div class="promotion-slogan1">
        {{  isChinese ? `帮助一般家庭吃到健康、美味、安全的海产品!` : `Help ordinary families eat healthy, delicious, and safe seafood!` }}
      </div>
    </div>
    <div class="partner">
      <div class="partner-title">{{ isChinese ? `合作伙伴` : `Partner` }}</div>
      <img src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/partner.png" alt="" />
    </div>
    <div class="contact">
      <div class="contact-title">{{  isChinese ? `联系方式` : 'Contact Information' }}</div>
      <div class="contact-img-container">
        <img src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/phone.png" alt="">
        <img src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/mail.png" alt="">
        <img src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/location.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(["isChinese"]),
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.contact-header {
  display: flex;
  flex-wrap: wrap;
  img {
    width: calc(100% / 3)
  }
}
.vision {
  margin: 100px 0;
  padding: 0 calc((100% - var(--breakpoint-x)) / 2);
  min-width: var(--breakpoint-z);
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;

  .vision-title,
  .promotion-slogan1,
  .promotion-slogan2,
  .promotion-slogan3 {
    font-size: 40px;
    font-weight: bold;
    font-style: italic;
  }
  .vision-title {
    margin-bottom: 50px;
    color: rgb(4, 109, 209);
  }
  .promotion-slogan1 {
    color: rgb(70, 210, 77);
  }
  .promotion-slogan2 {
    color: rgb(255, 110, 110);
  }
  .promotion-slogan3 {
    color: rgb(10, 113, 210);
  }
}
.partner {
  margin-bottom: 100px;
  padding: 0 calc((100% - var(--breakpoint-x)) / 2);
  min-width: var(--breakpoint-z);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;

  .partner-title {
    font-size: 40px;
    font-weight: bold;
    font-style: italic;
    margin-bottom: 50px;
    color: rgb(4, 109, 209);
  }
  img {
    width: 100%;
  }
}
.contact {
  margin-bottom: 100px;
  padding: 0 calc((100% - var(--breakpoint-x)) / 2);
  min-width: var(--breakpoint-z);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  .contact-title {
    font-size: 40px;
    font-weight: bold;
    font-style: italic;
    margin-bottom: 50px;
    color: rgb(4, 109, 209);
  }
  .contact-img-container {
    display: flex;
    flex-direction: row;
    gap: 60px;
    img {
      width: calc((100% - 120px) / 3);
    }
  }
}

@media (max-width: 1300px) {
  .partner,.contact,.vision {
    padding: 0 50px;
    margin-top: 100px;
  }
}
@media (max-width: 768px) {
  .contact-img-container {
    flex-wrap: wrap;
    gap: 20px;
    img {
      width: 100% !important;
    }
  }
}
</style>